import React from 'react'
import { useTranslation } from 'react-i18next'
import { Image } from '@fs/zion-ui'
import rtLogo from '../images/rt-logo-full.png'

export default function RootsTechLogo({ height = '40px' }) {
  const [t] = useTranslation()
  const width = Number.parseFloat(height) * 3.44825 // 40px height is 138px width, so we calculate the width based on the height

  // span is to keep the image from jumping size when the image loads
  return (
    <span style={{ height, width }}>
      <Image
        src={rtLogo}
        alt={t('rtlogo.alt-text', 'RootsTech by FamilySearch Logo')}
        height={height}
        width={width}
        noCrop
        positionX="left"
      />
    </span>
  )
}
